<template>
  <div>
    <!-- Button trigger modal -->
    <button
      type="button"
      class="btn btn-primary"
      data-bs-toggle="modal"
      data-bs-target="#showallGradesModal"
      @click="fetchGrades"
    >
      Show Grades
    </button>

    <!-- Modal -->
    <div
      class="modal fade"
      id="showallGradesModal"
      tabindex="-1"
      aria-labelledby="showallGradesModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h1 class="modal-title fs-5" id="showallGradesModalLabel">All Grades</h1>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body">
            <div v-if="grades.length">
              <table class="table table-bordered table-striped">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Grade Level</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(grade, index) in grades" :key="grade.id">
                    <td>{{ index + 1 }}</td>
                    <td>{{ grade.grade_level }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div v-else>
              <p>No grades found.</p>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-bs-dismiss="modal"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  data() {
    return {
      grades: [],
    };
  },
  methods: {
    async fetchGrades() {
      try {
        const response = await axios.get('/get-all-grades');
        this.grades = response.data;
      } catch (error) {
        console.error('Error fetching grades:', error);
      }
    },
  },
};
</script>

<style scoped>
.modal-lg {
  max-width: 800px;
}
</style>
